import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
// import Footer from "./components/Footer";
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Landing from './pages/Landing';
import LandingNavBar from './components/landing/landingnavbar/LandingNavBar';
import MainC from './components/main';
import HeaderNavbar from "./components/header/HeaderNavbar";
import Footer from "./components/footer/Footer";
import ScrollToTop from "./components/header/ScrollToTop";
// import WhatsAppButton from "./components/header/WhatsAppButton";

function App() {
  return (
    <div>

    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(


  <Router basename="/business">
  {/* <Router> */}
    {/* <ScrollToTop /> */}
    <HeaderNavbar />

    <Routes>
      {/* <Route path="/" element={<Landing />} /> */}
      <Route path="/" element={<LandingNavBar landing="landing" />} />
      <Route path="/aboutus" element={<LandingNavBar content="About us component" navBar="aboutus" />} />
      <Route path="/faq" element={<LandingNavBar content="FAQ component" navBar="faq" />} />
      {/* <Route path="/pricing" element={<LandingNavBar content="Pricing component" navBar="pricing" /> } /> */}
      <Route path="/pricing" element={<LandingNavBar navBar="pricing" page="pricing" />} />
      <Route path="/pricing/compare" element={<LandingNavBar navBar="pricing" page="compare" />} />
      <Route path="/demo" element={<LandingNavBar content="Demo component" navBar="demo" />} />
      <Route path="/blog" element={<LandingNavBar content="Blog component" navBar="blog" />} />
      <Route path="/contact" element={<LandingNavBar content="Contact component" navBar="contact" />} />
      {/* Removed login route - handled by main app via /business/login redirect */}
      <Route path="/printingmaterial" element={<LandingNavBar content="Printing Material component" navBar="printingmaterial" />} />
      {/* <Route path="/contact" element={<Contact />} /> */}
    </Routes>
    {/* <WhatsAppButton /> */}
    <Footer></Footer>
  </Router>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

